import { apiClient } from './client';

export type NotificationType = 'news' | 'trick' | 'warning';

export interface NotificationRole {
  id: number;
  roleId: number;
  name: string;
}

export interface Notification {
  id: number;
  type: NotificationType;
  typeLabel: string;
  name: string;
  message: string;
  page: string;
  url: string | null;
  startingDate: string | null;
  endingDate: string;
  roles: NotificationRole[];
  createdAt: string | null;
  updatedAt: string | null;
}

export interface NotificationTypeOption {
  value: string;
  label: string;
}

export interface CreateNotificationData {
  type: NotificationType;
  name: string;
  message: string;
  page: string;
  url?: string;
  startingDate?: string;
  endingDate: string;
  roleIds: number[];
}

export interface UpdateNotificationData {
  type?: NotificationType;
  name?: string;
  message?: string;
  page?: string;
  url?: string | null;
  startingDate?: string | null;
  endingDate?: string;
  roleIds?: number[];
}

export const notificationsApi = {
  async getAll(): Promise<Notification[]> {
    const response = await apiClient.get<Notification[]>('/api/v2/notifications');
    return response.data;
  },

  async getById(id: number): Promise<Notification> {
    const response = await apiClient.get<Notification>(`/api/v2/notifications/${id}`);
    return response.data;
  },

  async getTypes(): Promise<NotificationTypeOption[]> {
    const response = await apiClient.get<NotificationTypeOption[]>('/api/v2/notifications/types');
    return response.data;
  },

  async getRoles(): Promise<NotificationRole[]> {
    const response = await apiClient.get<NotificationRole[]>('/api/v2/notifications/roles');
    return response.data;
  },

  async create(data: CreateNotificationData): Promise<{ id: number; message: string }> {
    const response = await apiClient.post<{ id: number; message: string }>('/api/v2/notifications', data);
    return response.data;
  },

  async update(id: number, data: UpdateNotificationData): Promise<{ id: number; message: string }> {
    const response = await apiClient.put<{ id: number; message: string }>(`/api/v2/notifications/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/v2/notifications/${id}`);
  },
};
